'use client';

import React, { FC, JSX } from 'react';
import { ProductTeasersCarouselProps } from '@/components/productTeasers/ProductTeasersCarousel';
import dynamic from 'next/dynamic';
import LazyWrapper from '@/components/lazyWrapper/LazyWrapper';

const ProductTeasersCarousel = dynamic(
  () => import('@/components/productTeasers/ProductTeasersCarousel'),
  { ssr: false }
);

const ProductTeasersCarouselWrapper: FC<ProductTeasersCarouselProps> = (props): JSX.Element => {
  return (
    <LazyWrapper>
      <ProductTeasersCarousel {...props} />
    </LazyWrapper>
  );
};

export default ProductTeasersCarouselWrapper;
